import { SubsProduct } from 'models/SubsProduct'
import { SubsChannelProducts } from './SubsChannelProducts'

export type BoardItemPermissionType = 'all' | 'subscribers'

export type BoardItemPermissionParams = Readonly<{
    type: BoardItemPermissionType
    permittedSubsProducts: SubsProduct[] // 閲覧可能なプラン一覧
    isAllSubsProducts: boolean // 全てのプランで閲覧可能
}>

export class BoardItemPermission implements BoardItemPermissionParams {
    readonly type: BoardItemPermissionType
    readonly permittedSubsProducts: SubsProduct[]
    readonly isAllSubsProducts: boolean

    private constructor(params: BoardItemPermissionParams) {
        this.type = params.type
        this.permittedSubsProducts = params.permittedSubsProducts
            .sort((a, b) => a.tier - b.tier)
        this.isAllSubsProducts = params.isAllSubsProducts

        Object.freeze(this)
    }

    static of(params: BoardItemPermissionParams): BoardItemPermission {
        if (params instanceof BoardItemPermission) {
            return params
        } else {
            return new BoardItemPermission(params)
        }
    }

    static create(
        type: BoardItemPermissionType,
        subsChannelProducts: SubsChannelProducts,
        subsProductId?: string,
    ): BoardItemPermission {
        const permittedSubsProducts = subsChannelProducts.permittedProducts(subsProductId)
        const isAllSubsProducts = subsChannelProducts.isEqualIds(permittedSubsProducts)
        return new BoardItemPermission({
            type,
            permittedSubsProducts,
            isAllSubsProducts
        })
    }

    /**
     * 閲覧権限がある中でtierが一番小さいものを取得する
     */
    get minTierProduct(): SubsProduct | null {
        if (this.permittedSubsProducts.length === 0) {
            return null
        }
        return this.permittedSubsProducts[0]
    }

    hasPermission(subsProduct: SubsProduct): boolean {
        if (this.type === 'all') {
            return true
        }

        return this.permittedSubsProducts.some((item) => item.id === subsProduct.id)
    }
}
